/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('NotarizedFileRevision', ['$resource', function($resource) {
        var
            resource = $resource('/sync_and_share_nodes/notarized_file_revisions');

        resource.getDownloadUrl = function(node) {
            return node.actions.download;
        };

        return resource;
    }]);
